/**
 * Onboarding choice + chat routes.
 * Portal wizard lives at /onboarding/wizard (adminUserRoute).
 */
import { canShowOnboardingChoice, ONBOARDING_WIZARD_PATH } from './onboarding.guard.js';

export default [
  {
    path: '/onboarding',
    name: 'Onboarding Choice',
    component: () => import('./OnboardingChoice.vue'),
    meta: { hideLayout: true },
    beforeEnter(to, from, next) {
      // Choice screen: Company Admin (usertype02) + VH/Household only.
      if (!canShowOnboardingChoice()) {
        next({ path: ONBOARDING_WIZARD_PATH, replace: true });
        return;
      }
      next();
    },
  },
  {
    path: '/onboarding/chat',
    name: 'Onboarding Chat',
    component: () => import('@/views/dashboard/onboarding.vue'),
    meta: { moduleCode: 2312, hideLayout: true, onboardingMode: 'chat' },
  },
];
